import { HandleChangeProps } from "DataTypes/Common";
import { DropdownArrPropsType, FormDataType } from "DataTypes/Form";
import FormValidation from "./Validation";
import { useSearchParams } from "react-router-dom";
import { ChipProps } from "@mui/material";
import dayjs from "dayjs";

export const HandleFormChange: (
  data: HandleChangeProps,
  formArr: FormDataType[]
) => FormDataType[] = ({ value, id }, formArr) => {
  return formArr.map((formEl) => {
    if (formEl.id == id) {
      formEl.value = formEl.dropValue = value;
      const temp = FormValidation(formEl);
      formEl.error = temp.error;
      formEl.errorText = temp.errorText;
    }
    return formEl;
  });
};
export const CheckStringEmpty: (data: any) => string = (data) => {
  const string1 = typeof data == "string" ? data : "";
  const string2 = string1.trim();
  const string3 = string2.replaceAll(/&nbsp;/g, " ");
  return string3;
};

export const CheckNumber: (data: any) => number | null = (data) => {
  return typeof data == "number" ? data : null;
};

export const CheckArr: (data: any) => any[] = (data) => {
  return Array.isArray(data) ? data : [];
};

export const ValidateFormData: (formData: FormDataType[]) => {
  formData: FormDataType[];
  errorCheck: boolean;
} = (formData) => {
  let singleEntryErrorCheck = false;
  const newArr = formData.map((el) => {
    let result = { error: false, errorText: "" };
    if (el.required || el.value) result = FormValidation(el);
    if (result.error) singleEntryErrorCheck = true;
    el.errorText = result.errorText;
    el.error = result.error;
    return el;
  });
  return { formData: newArr, errorCheck: singleEntryErrorCheck };
};

export const FormatDropdownData: (
  data: any,
  idKey: string,
  labelKey: string,
  valKey: string
) => DropdownArrPropsType[] = (data, idKey, labelKey, valKey) => {
  return data?.map((el: any, index: number) => ({
    id: idKey ? el[idKey] : index,
    label: el[labelKey],
    value: el[valKey],
  }));
};

export const filterByAnyValue = (array: any, input: string) => {
  if (!input) return array;

  const lowerInput = input.toLowerCase();

  return array.filter((item: any) =>
    Object.values(item).some(
      (val) =>
        val !== null &&
        val !== undefined &&
        val.toString().toLowerCase().includes(lowerInput)
    )
  );
};

export const Admin_Number = 9326024128;

// Constants for file restriction
export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILE_SIZE = 10;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const useSavedData = () => {
  const [searchParams] = useSearchParams();

  const getSavedData = () => {
    try {
      const saved = localStorage.getItem("userPurchaseData");
      if (saved) {
        return JSON.parse(saved);
      }

      const dataParam = searchParams.get("data")
      if (dataParam) {
        const decoded = JSON.parse(decodeURIComponent(dataParam));

        localStorage.setItem("userPurchaseData", JSON.stringify(decoded));
        return decoded;
      }
    } catch (err) {
      console.error("❌ Error reading saved data:", err);
    }

    return null;
  };

  return getSavedData;
};

// Function to get hex color codes based on status
export const getStatusColorHex = (status: string) => {
  const map: Record<string, { bg: string; text: string }> = {
    Charge: { bg: "#DCFCE7", text: "#166534" }, // Light Green
    Refund: { bg: "#F0F9FF", text: "#075985" }, // Light Blue
    PaymentCompleted: { bg: "#DCFCE7", text: "#0a0a0aff" }, // Green
    Success: { bg: "#DCFCE7", text: "#166534" }, // Green
    PaymentPending: { bg: "#c7caf7ff", text: "#151616ff" }, // Amber/Orange
    PaymentFailed: { bg: "#FEE2E2", text: "#991B1B" }, // Red
    Refunded: { bg: "#F3F4F6", text: "#1F2937" }, // Gray
    Processing: { bg: "#E0E7FF", text: "#3730A3" }, // Indigo
    PaymentNotCompleted: { bg: "#FEE2E2", text: "#991B1B" },
  };
  return map[status] || { bg: "#F3F4F6", text: "#1F2937" };
};

export const formatDate = (date: string) => dayjs(date).format("DD MMM YYYY, hh:mm A");

export const getPaymentStatusDetails = (statusCode: number | string) => {
    const statusMapping: Record<number | string, { label: string; color: string; bg: string }> = {
        0: { label: "Payment Pending", color: "#FFA500", bg: "#FFF4E5" },       // Orange
        1: { label: "Payment Completed", color: "#2E7D32", bg: "#EDF7ED" },     // Green
        2: { label: "Cancelled", color: "#757575", bg: "#F5F5F5" },             // Gray
        3: { label: "Payment Not Completed", color: "#D32F2F", bg: "#FDECEA" }, // Red
        4: { label: "Payment Failed", color: "#C62828", bg: "#FFEBEE" }         // Dark Red
    };

    // Return the mapped status or a default 'Unknown' fallback
    return statusMapping[statusCode] || { label: "Unknown", color: "#000000", bg: "#E0E0E0" };
};


export const navigation = {
  navigate: null as any,
};

export const safeNavigate = (path: string) => {
  if (navigation.navigate) {
    navigation.navigate(path);
  } else {
    window.location.replace(path); // Fallback
  }
};

// get current year
export const currentYear = new Date().getFullYear();

// default date of birth
export const defaultDOB = new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString();

// humanize internal user role constants
export const formatUserType = (type?: string) => {
  if (!type) return "";
  const types: Record<string, string> = {
    "USER": "User",
    "ADMIN": "Admin",
    "SUPERADMIN": "Super Admin",
    "PROFESSIONAL": "Professional",
    "E_MITRA_USER": "e-Mitra User",
    "CORPORATEUSER": "Corporate User",
    "NRIUSER": "NRI User"
  };
  return types[type.toUpperCase()] || type;
};